import Vue from 'vue';
import VueMarkdown from 'vue-markdown';
import { Accordion } from '@/components';
export default Vue.extend({
    name: 'FAQList',
    props: {
        faqCount: {
            type: Number,
            default: null,
        },
        featured: {
            type: Boolean,
            default: false,
        },
        search: {
            type: String,
            default: '',
        },
        pagination: {
            type: Boolean,
            default: false,
        },
        page: {
            type: Number,
            default: 1,
        },
        itemsPerPage: {
            type: Number,
            default: 7,
        },
        items: {
            type: Array,
            default: () => [],
        },
    },
    components: {
        Accordion,
        VueMarkdown,
    },
    data: () => ({
        faqs: [],
    }),
    created() {
        this.faqs = this.items;
    },
    watch: {
        items: {
            immediate: true,
            handler(val) {
                this.faqs = val;
            },
        },
    },
    computed: {
        showCount() {
            var _a, _b;
            return (_a = this.faqCount) !== null && _a !== void 0 ? _a : (_b = this.faqs) === null || _b === void 0 ? void 0 : _b.length;
        },
        faqsToShow() {
            let results = this.faqs;
            if (this.featured) {
                results = results.filter((faq) => faq.featured);
            }
            if (this.search) {
                const query = this.search.toLowerCase().trim();
                results = results.filter((faq) => {
                    return (faq.q.toLowerCase().includes(query) ||
                        faq.a.toLowerCase().includes(query));
                });
            }
            if (this.pagination) {
                return results.slice((this.page - 1) * this.itemsPerPage, this.page * this.itemsPerPage);
            }
            return results.slice(0, this.showCount).map((item) => ({
                ...item,
                isOpen: false,
            }));
        },
    },
    methods: {
        highlight(words) {
            const query = String(this.search || '').toLowerCase();
            if (!query)
                return words;
            let iQuery = new RegExp(query, 'ig');
            return words.toString().replace(iQuery, function (matchedTxt) {
                return "<span class='highlight'>" + matchedTxt + '</span>';
            });
        },
    },
});
